<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>menu.searchVoucher</h3>
        </span>
    </div>

    <div class="my-2 py-2" *ngIf="loadSearchForm$ | async as data; else loading">
        <!-- ****************************************************** 
        ************** Search Form *************
        ****************************************************** -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- voucher name -->
                <ng-container>
                    <div class="input-group-prepend">
                        <span class="input-group-text" translate>voucher.name</span>
                    </div>
                    <input type="text" class="form-control d-inline" (keyup.enter)="search()" formControlName="name" id="nameInput">
                </ng-container>
                
                <!-- status  -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>promotion.status</span>
                </div>
                <select class="custom-select input-custom-size" [compareWith]="compareById" formControlName="status">
                    <option value="" [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let status of statuses" [ngValue]="status"> {{status.name}}
                </select>
                
                <!-- service -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate> promotion.service</span>
                </div>
                <select class="custom-select input-custom-size" [compareWith]="compareById" formControlName="service">
                    <option value="" [ngValue]="null" translate>placeholder.select</option>
                    <option *ngFor="let service of services" [ngValue]="service"> {{service.name}}
                </select>

                <ng-container>
                    <!-- actions -->
                    <div class="input-group-prepend ml-2">
                        <div style="display: flex;">
                            <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                            <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                            <button class="btn btn-outline-success ml-2" style="border-radius: 0;" routerLink="/add-edit-voucher"
                                type="button" *ngIf="canAddEdit" translate>button.add</button>
                            <i class="fa fa-file-excel-o fa-2x" data-toggle="tooltip" data-placement="bottom" title="{{'button.excel' | translate}}" style="margin-left: 10px; margin-top: 2px" (click)="exportExcel()"></i>
                            <i style="margin-left: 5px; margin-top: 2px" data-toggle="tooltip" data-placement="bottom" title="{{'button.pdf' | translate}}" class="fa fa-file-pdf-o fa-2x" (click)="exportPDF()"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
        <ng-container *ngIf="!loadPdfOrExcel; else dataLoadingTemplate"></ng-container>
        <br>
        <!-- ****************************************************** 
        ************** Table Data *************
        ****************************************************** -->
        <div class=" d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th sortBy="name" (sort)="onSort($event)" translate>voucher.name</th>
                        <th translate>voucher.discountKind</th>
                        <th translate>voucher.discount</th>
                        <th translate>voucher.type</th>
                        <th sortBy="points" (sort)="onSort($event)" translate>voucher.points</th>
                        <th translate>voucher.inspectionsCount</th>
                        <th sortBy="status" (sort)="onSort($event)" translate>voucher.status</th>
                        <th sortBy="validFrom" (sort)="onSort($event)" translate>voucher.validFrom</th>
                        <th sortBy="validTo" (sort)="onSort($event)" translate>voucher.validTo</th>
                        <th translate>voucher.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let voucher of content">
                        <td>{{voucher.name}}</td>
                        <td>{{voucher.priceAttributeKind === 'V' ? 'Стойност' : voucher.priceAttributeKind === 'P' ? 'Процент' : voucher.priceAttributeKind}}</td>
                        <td>{{voucher.priceAttributeAmountDds != null ? voucher.priceAttributeAmountDds : voucher.priceAttributeAmount}}</td>
                        <td>{{voucher.voucherConfigurationTypeName}}</td>
                        <td>{{voucher.points}}</td>
                        <td>{{voucher.inspectionsCount}}</td>
                        <td>{{voucher.status?.name}}</td>
                        <td>{{voucher.validFrom}}</td>
                        <td>{{voucher.validTo}}</td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" routerLink="/add-edit-voucher" *ngIf="canView"
                            data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}" 
                            [queryParams]="{id: voucher.id}"><i class="fa fa-pencil fa-lg"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
        <!-- ****************************************************** 
        ************** Pagination *************
        ****************************************************** -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}} 
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #loading>
    <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #spinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>

<ng-template #dataLoadingTemplate>
        <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #dataSpinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
</ng-template>